export const prefix = "kestrel";

export const ssrDataAttribute = "data-kestrel-data";

export const entryRouteIdAttribute = "data-kestrel-route";

export const entryAppIdAttribute = "data-kestrel-app";

export const entryIslandAttribute = "data-kestrel-island";
